/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Grid, Toolbar } from '@mui/material';
import { PrayView } from '../../common';
import '../styles/local-style.css';
import * as StorageService from '../../common/services/storage-services';


export default function ReportView() {
  const settings = useSelector((state) => state.settings);
  const user = useSelector((state) => state.user);
  const [refreshCount, setrefreshCount] = useState(0);
  const [token, settoken] = useState(user.access_token);

  const handleTokenRefresh = (event) => {
    const userObj = StorageService.get('PRAY_AUTH_USER');
    setrefreshCount(refreshCount + 1);
    settoken(userObj.access_token);
  };

  let selectedLink = null;
  const location = useLocation();
  const pathname = location.pathname;
  if (settings.features != null) {
    settings.features.map((item) => {
      item.links.map((link) => {
        if (link.link === pathname) {
          selectedLink = link;
        }
        return null;
      });
      return null;
    });
  }

  useEffect(() => {
    window.addEventListener('token_refreshed', handleTokenRefresh);
    return () => {
      console.log('Unmount');
    };
  });
  return (
    <>
      <PrayView viewName={'Report - '+selectedLink.name}>
        <Grid sx={{ flex: 1, height: '100%', p: 0, position: 'relative' }}>
          <Toolbar />
          {(selectedLink != null) &&
            <iframe key={refreshCount} title={selectedLink.name} frameBorder="0" className='analytic-report-container' src={`${selectedLink.reportUrl}?params=%7B%22ds0.token%22%3A%22${token}%22%2C%20%22ds1.token%22%3A%22${token}%22%7D`} />
          }
        </Grid>
      </PrayView>
    </>
  );
};
